module.exports = __webpack_public_path__ + "img/s1v3t2.9c86c938.jpg";